/** Server-resolved source text, highlights and frozen respondent profile. No client-side provenance inference. */
import * as z from 'zod';
import { savedRespondentProfileSchema, resultSourceLabelsSchema } from './response-source-profile.js';
const text = z.string();
const nullableText = text.nullable();
const sourceExchangeSchema = z.strictObject({
    label: text,
    source: text,
    sourceLinkLabel: text,
    sourceLabels: resultSourceLabelsSchema,
    profile: savedRespondentProfileSchema.nullable(),
    answers: z
        .array(z.strictObject({
        id: text,
        question: text,
        originLabel: text.optional(),
        response: text,
        selected: z.boolean(),
        segments: z.array(z.strictObject({ text, highlighted: z.boolean() })),
    }))
        .min(1),
});
const quoteFields = {
    id: text,
    source: text,
};
export const resultQuoteSchema = z.discriminatedUnion('citationUnit', [
    z.strictObject({
        ...quoteFields,
        citationUnit: z.literal('answer'),
        question: nullableText,
        segments: z.array(z.strictObject({
            text,
            highlighted: z.boolean(),
            sourceTarget: z
                .strictObject({
                answerId: text,
                segments: z.array(z.strictObject({ text, highlighted: z.boolean() })),
            })
                .optional(),
        })),
        originalExchange: sourceExchangeSchema.nullable(),
    }),
    z.strictObject({
        ...quoteFields,
        citationUnit: z.literal('exchange'),
        question: z.null(),
        segments: z.array(z.strictObject({ text, highlighted: z.boolean() })).length(0),
        originalExchange: sourceExchangeSchema,
    }),
]);
//# sourceMappingURL=shopify-study-results-source.js.map